import React from 'react'
import { SkeletonLoader } from '@core/Areas/BetLoop/Components/Common/SkeletonLoader'
import { SharedBetCard } from '@core/Areas/BetLoop/Components/Common/SharedBetCard'
import { EmptyMessage } from '@core/Areas/BetLoop/Components/Common/EmptyMessage'
import { useSharedBetsData } from '@core/Areas/BetLoop/hooks/useSharedBetsData'
import { useIsBetLoopSportsFeatureActive } from '@core/Areas/BetLoop/hooks/useIsBetLoopSportsFeatureActive'

export const ResultedBets: React.FC<{
  profileId: string
  isUsingScrollRestore: boolean
  incomingPostId?: number
}> = ({ profileId, incomingPostId, isUsingScrollRestore }) => {
  const isBetLoopSportActive = useIsBetLoopSportsFeatureActive()

  const { isLoading, data, isRefetching, LoadMoreButton } = useSharedBetsData({
    feedType: 'resulted',
    accountId: profileId,
    sortOrder: 'sortDesc',
    type: isBetLoopSportActive ? 'all' : 'racing',
  })

  const shouldDisplayPreviousData = isUsingScrollRestore && Boolean(data?.pages)
  if (!shouldDisplayPreviousData && (isLoading || isRefetching)) return <SkeletonLoader />

  const resultedBetsData = data?.pages.flat()

  if (!resultedBetsData || resultedBetsData.length === 0)
    return (
      <EmptyMessage
        messageType='non-bettable-tip'
        title='No Shared Bets'
        description='No bets shared at the moment, check back later or refresh the page'
      />
    )

  const resultedBets = incomingPostId
    ? resultedBetsData.filter(bet => bet.postId !== incomingPostId)
    : resultedBetsData

  return (
    <>
      {resultedBets.map(sharedBet => (
        <SharedBetCard
          key={`${sharedBet.postId}.${sharedBet.ownerAccountId}`}
          sharedBet={sharedBet}
        />
      ))}

      <LoadMoreButton />
    </>
  )
}
